<ng-content></ng-content>
<button
  tabindex="0"
  class="navbar-toggler"
  type="button"
  (click)="toggle($event)"
  *ngIf="this.el.nativeElement.children.length !== 0"
>
  <span class="navbar-toggler-icon"></span>
</button>
<ng-content select="pmd-navbar-brand"></ng-content>
<div
  #navbar
  [style.height]="height"
  class="navbar-collapse collapse pmd-navbar-sidebar"
  [ngClass]="{ 'pmd-sidebar-open': showClass }"
>
  <ng-content select="pmd-navbar-collapse"></ng-content>
</div>
<ng-content select="pmd-navbar-right-icon"></ng-content>
<div
  class="pmd-navebar-overlay"
  (click)="overlaytoggle($event)"
  [ngClass]="{ 'pmd-navebar-overlay-active': showClass }"
></div>
